import { render, staticRenderFns } from "./PatientShowContent.vue?vue&type=template&id=2ff0f7f1&scoped=true&"
import script from "./PatientShowContent.vue?vue&type=script&lang=js&"
export * from "./PatientShowContent.vue?vue&type=script&lang=js&"
import style0 from "./PatientShowContent.vue?vue&type=style&index=0&id=2ff0f7f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff0f7f1",
  null
  
)

export default component.exports